var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.onExport}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Excel\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }